// extracted by mini-css-extract-plugin
module.exports = {"image":"loadable-image_image__zBlbT","loaded":"loadable-image_loaded__dn6Yt"};